import React from 'react'
import View from '../View'
import { navigationController } from 'components/Modal'

const LeftSidebarView = React.forwardRef<View, React.ComponentPropsWithRef<typeof View>>((props, ref) => {
  const { pop } = navigationController.useActions()

  return (
    <View
      {...props}
      ref={ref}
      onCloseClick={pop}
    />
  )
})

export default LeftSidebarView
